// ---------------------------------------------------------------------------
// Monster species that attack at night
// ---------------------------------------------------------------------------

export interface MonsterSpecies {
  id: string;
  name: string;
  hp: number;
  speed: number;          // pixels per second
  attackPower: number;
  defense: number;
  xpReward: number;
  coinReward: number;
  spriteRow: number;      // row in the monsters sprite sheet
  description: string;
}

export const MONSTERS: Record<string, MonsterSpecies> = {
  piranha_plant: {
    id: 'piranha_plant',
    name: 'Piranha Plant',
    hp: 25,
    speed: 35,
    attackPower: 8,
    defense: 3,
    xpReward: 15,
    coinReward: 5,
    spriteRow: 0,
    description: 'A savage walking plant with razor-sharp teeth. Stalks farms at night looking for fresh crops to devour.',
  },
  thorn_crawler: {
    id: 'thorn_crawler',
    name: 'Thorn Crawler',
    hp: 20,
    speed: 50,
    attackPower: 5,
    defense: 2,
    xpReward: 10,
    coinReward: 3,
    spriteRow: 1,
    description: 'A fast-moving thorny vine creature that skitters across the ground. Weak but arrives in swarms.',
  },
  fungal_brute: {
    id: 'fungal_brute',
    name: 'Fungal Brute',
    hp: 50,
    speed: 20,
    attackPower: 15,
    defense: 8,
    xpReward: 30,
    coinReward: 10,
    spriteRow: 2,
    description: 'A massive mushroom beast that lumbers toward your farm. Slow but hits hard and takes punishment.',
  },
  wilt_wraith: {
    id: 'wilt_wraith',
    name: 'Wilt Wraith',
    hp: 30,
    speed: 30,
    attackPower: 12,
    defense: 1,
    xpReward: 20,
    coinReward: 8,
    spriteRow: 3,
    description: 'A ghostly withered plant spirit. Phases through obstacles and drains life from anything it touches.',
  },
  root_titan: {
    id: 'root_titan',
    name: 'Root Titan',
    hp: 120,
    speed: 15,
    attackPower: 20,
    defense: 15,
    xpReward: 50,
    coinReward: 25,
    spriteRow: 4,
    description: 'A boss-tier monster made of twisted ancient roots. Only appears on blood moon nights.',
  },
};

// Which monsters spawn at which difficulty tiers (based on day count)
export const MONSTER_WAVES: { minDay: number; monsters: string[]; maxCount: number }[] = [
  { minDay: 1, monsters: ['piranha_plant'], maxCount: 2 },
  { minDay: 3, monsters: ['piranha_plant', 'thorn_crawler'], maxCount: 3 },
  { minDay: 5, monsters: ['piranha_plant', 'thorn_crawler', 'fungal_brute'], maxCount: 4 },
  { minDay: 8, monsters: ['piranha_plant', 'thorn_crawler', 'fungal_brute', 'wilt_wraith'], maxCount: 5 },
  { minDay: 12, monsters: ['thorn_crawler', 'fungal_brute', 'wilt_wraith', 'root_titan'], maxCount: 6 },
];
